/* eslint react/no-multi-comp: 0, react/prop-types: 0 */
// eslint-disable-next-line
import React, { Fragment, useState, useEffect } from 'react';
import { Row, Col, Badge } from 'react-bootstrap'; // eslint-disable-next-line
import avatar_img from '../../assets/img/team/avatar.svg'; // eslint-disable-next-line
import { copiriAxiosPost, copiriPortalRequest, parseDateString } from '../api/api'; // eslint-disable-next-line
import config from '../config/config'; // eslint-disable-next-line
import CopiriLoader from '../common/CopiriLoader';
import EditProfileNameModal from './EditProfileNameModal';
import AddEditProfileAddressModal from './AddEditProfileAddressModal';
import AddEditProfileEmailModal from './AddEditProfileEmailModal';
import AddEditProfilePhoneModal from './AddEditProfilePhoneModal';
import EditProfileDateModal from './EditProfileDateModal';
import { copy } from './Common';
import { genPageData } from '../langconfig/langconfig'; // eslint-disable-next-line
const UserProfilePersonalInforamtion = ({ data, pageLanguageContent, updateData, userAddressData }) => {
	const [showHideEditProfileNameModal, setShowHideEditProfileNameModal] = useState(false); // eslint-disable-next-line
	const [showHideAddEditAddressModal, setShowHideAddEditAddressModal] = useState(false); // eslint-disable-next-line
	const [showHideAddEditEmailModal, setShowHideAddEditEmailModal] = useState(false); // eslint-disable-next-line
	const [showHideAddEditPhoneModal, setShowHideAddEditPhoneModal] = useState(false); // eslint-disable-next-line
	const [countriesData, setCountriesData] = useState([]); // eslint-disable-next-line
	const [stateData, setStateData] = useState([]); // eslint-disable-next-line
	const [type, setType] = useState('');
	const [copiriGenderList, setCopiriGenderList] = useState([]);
	const [showHideEditProfileDateModal, setShowHideEditProfileDateModal] = useState(false); // eslint-disable-next-line
	const [date, setDate] = useState();
	const [dateGenderType, setDateGenderType] = useState('');
	const [itemData, setItemData] = useState('');
	const [inputField, setInputField] = useState({
		first_name: data['first_name'],
		last_name: data['last_name'],
		second_last_name: data['last_name_second'],
		middle_name: data['middle_name'],
		name_full: data['name_full'],
		suffix_id: data['suffix_id'],
		suffix: data['suffix'],
		email: data['email'],
		phone: data['phone'] ? data['phone'] : '',
		gender: data['gender'] ? data['gender'] : '',
		gender_id: data['gender_id'] ? data['gender_id'] : '',
		dial: '',
		name_pref: data['name_pref'],
		facility_name: '',
		street_address_1: '',
		street_address_2: '',
		street_address_3: '',
		city: '',
		post_code: '',
		country: '',
		country_id: '',
		birthdate: data['birthdate'],
		state: '',
		state_id: '',
		spouse_first_name: data?.spouse?.first_name,
		spouse_middle_name: data?.spouse?.middle_name,
		spouse_last_name: data?.spouse?.last_name_one,
		spouse_suffix: data?.spouse?.suffix_id,
		spouse_gender: data?.spouse?.gender,
		spouse_gender_id: data?.spouse?.gender_id,
		spouse_preferred_name: data?.spouse?.preferred_name,
		spouse_second_last_name: data?.spouse?.last_name_two
	});
	const [dailCodes, setDailCodes] = useState([]);
	const options = {
		year: 'numeric',
		month: 'long',
		day: 'numeric'
	};

	useEffect(() => {
		getCopiriGenderList();
		getDailCode();
		if (data.birthdate) {
			let dateObj = parseDateString(data.birthdate);
			let user_dob = dateObj.toLocaleDateString('en-US', options);
			setDate(user_dob);
		}
		// eslint-disable-next-line
	}, [data]);

	function getDailCode() {
		setDailCodes([]);
		copiriPortalRequest('/canon/dialcodes', config.app_version, 'get')
			.then(response => {
				if (response.data.length > 0) {
					setDailCodes(response.data);
				}
			})
			.catch(error => {});
	}

	function getCopiriGenderList() {
		copiriPortalRequest('/canon/lists/copiri_sex', config.app_version, 'get')
			.then(response => {
				if (response.data.length > 0) {
					setCopiriGenderList(response.data);
				}
			})
			.catch(error => {});
	}

	const showHideModal = (type, itemData = '') => {
		setType(type);
		if (type === 'edit_name') {
			setShowHideEditProfileNameModal(true);
		}
		if (type === 'add_address' || type === 'edit_address') {
			setShowHideAddEditAddressModal(true);
			getCountriesData();
			if (type === 'add_address') {
				setItemData('');
			}
			if (type === 'edit_address') {
				setItemData(itemData);
			}
		}

		if (type === 'add_email' || type === 'edit_email') {
			setShowHideAddEditEmailModal(true);
		}

		if (type === 'add_phone' || type === 'edit_phone') {
			setShowHideAddEditPhoneModal(true);
		}
		if (type === 'edit_date') {
			setShowHideEditProfileDateModal(true);
			setDateGenderType('dob');
		}
		if (type === 'edit_gender') {
			setShowHideEditProfileDateModal(true);
			setDateGenderType('gender');
		}

		if (type === 'edit_spouse') {
			setShowHideEditProfileNameModal(true);
		}
	};
	const closeAllModals = () => {
		setShowHideEditProfileNameModal(false);
		setShowHideAddEditAddressModal(false);
		setShowHideAddEditEmailModal(false);
		setShowHideAddEditPhoneModal(false);
		setShowHideEditProfileDateModal(false);
	};

	const updateModal = (type, id, inputFields, date = '') => {
		if (type === 'edit_date') {
			let c_date = parseDateString(data.birthdate);
			let user_dob = c_date.toLocaleDateString('en-US', options);
			setDate(user_dob);
			updateData(id, inputFields, date);
		} else {
			updateData(id, inputFields);
		}
	};

	/* function to get country data */
	function getCountriesData() {
		copiriPortalRequest('/canon/countries', config.app_version, 'get')
			.then(response => {
				setCountriesData(response.data);
			})
			.catch(error => {});
	}

	function copyContent(content) {
		copy(content);
	}

	return (
		<>
			<fieldset className='border p-2'>
				<legend className='w-auto'>{pageLanguageContent['PRL041'] ? pageLanguageContent['PRL041'] : ''}</legend>
				<Row className='mt-2'>
					<Col lg={5}>
						<strong className='bold-text'>
							{pageLanguageContent['PRL083'] ? pageLanguageContent['PRL083'] : ''}:{' '}
						</strong>
					</Col>
					<Col lg={5}>
						<span className='user_profile_text'>{data['name_full']}</span>
					</Col>
					<Col lg={2} className='modalRightContent btn-badge'>
						{data['id'] && (
							<Badge
								bg={''}
								className='badge badge-soft-info'
								onClick={() => showHideModal('edit_name')}
								data-toggle='tooltip'
								title={genPageData['GENEDT'] ? genPageData['GENEDT'] : ''}
							>
								<i className='far fa-edit profileEditContent'></i>
							</Badge>
						)}
					</Col>
				</Row>
				<Row className='mt-2'>
					<Col lg={5}>
						<strong className='bold-text'>{pageLanguageContent['PRL152'] ? pageLanguageContent['PRL152'] : ''}:</strong>
					</Col>
					<Col lg={5}>
						<span className='user_profile_text'> {data['birthdate'] ? date : ' '}</span>
					</Col>
					<Col lg={2} className='modalRightContent btn-badge'>
						<Badge
							bg={''}
							onClick={() => showHideModal('edit_date')}
							data-toggle='tooltip'
							title={pageLanguageContent['PRL153'] ? pageLanguageContent['PRL153'] : ''}
							className='ml-2 user-copy-icon badge badge-soft-info'
							style={{ display: 'inline-flex' }}
						>
							<i className='far fa-edit'></i>
						</Badge>
					</Col>
				</Row>

				<Row className='mt-2'>
					<Col lg={5}>
						<strong className='bold-text'>{pageLanguageContent['PRL153'] ? pageLanguageContent['PRL153'] : ''}:</strong>
					</Col>
					<Col lg={5}>
						<span className='user_profile_text'> {data['gender'] ? data['gender'] : ' '}</span>
					</Col>
					<Col lg={2} className='modalRightContent btn-badge'>
						<Badge
							onClick={() => showHideModal('edit_gender')}
							bg={''}
							className='ml-2 user-copy-icon badge badge-soft-info'
							style={{ display: 'inline-flex' }}
						>
							{' '}
							<i className='far fa-edit'></i>
						</Badge>
					</Col>
				</Row>
				<Row className='mt-2'>
					<Col lg={5}>
						<strong className='bold-text'>{pageLanguageContent['PRL146'] ? pageLanguageContent['PRL146'] : ''}:</strong>
					</Col>
					<Col lg={5}>
						<span className='user_profile_text'>
							{' '}
							{data?.spouse?.first_name} {data?.spouse?.last_name_one}
						</span>
					</Col>
					<Col lg={2} className='modalRightContent btn-badge'>
						<Badge
							bg={''}
							className='badge badge-soft-info'
							onClick={() => showHideModal('edit_spouse')}
							data-toggle='tooltip'
							title={genPageData['GENEDT'] ? genPageData['GENEDT'] : ''}
						>
							<i className='far fa-edit profileEditContent'></i>
						</Badge>
					</Col>
				</Row>
				<Row className='mt-2 mb-1'>
					<Col lg={8}>
						<strong className='bold-text'>{pageLanguageContent['PRL084'] ? pageLanguageContent['PRL084'] : ''}</strong>
					</Col>
					<Col lg={4} className='modalRightContent'>
						<Badge
							bg={''}
							className='badge badge-soft-secondary'
							role='button'
							onClick={() => showHideModal('add_address', '')}
						>
							<i className='far fa-plus mr-1'></i>
							{pageLanguageContent['PRL085'] ? pageLanguageContent['PRL085'] : ''}
						</Badge>
					</Col>
				</Row>

				<Row>
					<Col lg={12} className='mb-1'>
						<hr />
					</Col>
				</Row>

				<Row className='mb-1'>
					{userAddressData && userAddressData.length > 0 ? (
						userAddressData.map((item, i) => (
							<>
								{(item.city || item.state || item.country) && (
									<>
										<Col lg={8} md='6' sm='12' className='mb-1'>
											<span>{item?.facility}</span>
											{item.facility && item.facility !== '' && item.facility != null && <>, </>}
											<span>
												{item?.city}
												{item.city && <>, </>}
												{item.state}
												{item.state && <>, </>}
											</span>
											<span>{item.country && <>{item.country}</>}</span>
											<span>{item.post_code && <>, {item.post_code}</>}</span>
										</Col>
										<Col lg={4} md='6' sm='12' className='modalRightContent btn-badge'>
											<Badge
												bg={''}
												className='ml-2 badge badge-soft-secondary'
												onClick={() => showHideModal('edit_address', item)}
											>
												<i className='far fa-edit profileEditContent'></i>
											</Badge>
										</Col>
									</>
								)}
							</>
						))
					) : (
						<Col lg={12} md='6' sm='12' className='mb-1'>
							<p style={{ textAlign: 'center' }}>
								{pageLanguageContent['PRL086'] ? pageLanguageContent['PRL086'] : ''}.
							</p>
						</Col>
					)}
				</Row>

				<br />
				<Row>
					<Col lg={8} className='mb-1'>
						<strong className='bold-text'>{pageLanguageContent['PRL087'] ? pageLanguageContent['PRL087'] : ''}</strong>
					</Col>
					<Col lg={4} className='modalRightContent'>
						<Badge bg={''} className='ml-2 badge badge-soft-secondary' onClick={() => showHideModal('add_email')}>
							<i className='far fa-plus mr-1'></i>
							{pageLanguageContent['PRL088'] ? pageLanguageContent['PRL088'] : ''}
						</Badge>
					</Col>
				</Row>

				<Row>
					<Col lg={12} className='mb-1'>
						<hr />
					</Col>
				</Row>

				<Row className='mb-1'>
					{data['email'] && data['email'] !== '' ? (
						<>
							<Col lg={8} md='6' sm='12' className='mb-1'>
								<span>{data['email']}</span>

								{!data['email_validated'] && (
									<Badge bg={''} className='mr-2 badge badge-soft-danger' style={{ marginLeft: '10px' }}>
										<i className='fas fa-exclamation-triangle'></i>{' '}
										{pageLanguageContent['PRL159'] ? pageLanguageContent['PRL159'] : ''}
									</Badge>
								)}
							</Col>
							<Col lg={4} md='6' sm='12' className='modalRightContent btn-badge'>
								<Badge
									bg={''}
									className='mr-2 userProfileModalCopy badge-soft-info'
									onClick={() => copyContent(data['email'])}
									data-toggle='tooltip'
									title={genPageData['GENCPY'] ? genPageData['GENCPY'] : ''}
								>
									<i className='far fa-copy'></i>
								</Badge>
								<Badge
									bg={''}
									className='badge-soft-info'
									onClick={() => showHideModal('edit_email')}
									data-toggle='tooltip'
									title={genPageData['GENEDT'] ? genPageData['GENEDT'] : ''}
								>
									<i className='far fa-edit profileEditContent'></i>
								</Badge>
							</Col>
						</>
					) : (
						<Col lg={12} md='6' sm='12' className='mb-1'>
							<p style={{ textAlign: 'center' }}>
								{pageLanguageContent['PRL086'] ? pageLanguageContent['PRL086'] : ''}.
							</p>
						</Col>
					)}
				</Row>
				<br />
				<Row className='mb-1'>
					<Col lg={8}>
						<strong className='bold-text'>{pageLanguageContent['PRL089'] ? pageLanguageContent['PRL089'] : ''}</strong>
					</Col>
					<Col lg={4} className='modalRightContent'>
						<Badge
							bg={''}
							className='ml-2 badge badge-soft-secondary'
							role='button'
							onClick={() => showHideModal('add_phone')}
						>
							<i className='far fa-plus mr-1'></i>
							{pageLanguageContent['PRL090'] ? pageLanguageContent['PRL090'] : ''}
						</Badge>
					</Col>
				</Row>

				<Row>
					<Col lg={12}>
						<hr />
					</Col>
				</Row>

				<Row>
					{data['phone'] && data['phone'] !== '' ? (
						<>
							<Col lg={8} md='6' sm='12' className='mb-1'>
								<span id='user_phone_no'>+{data['phone']}</span>
							</Col>
							<Col lg={4} md='6' sm='12' className='modalRightContent btn-badge'>
								<Badge
									bg={''}
									className='ml-2 badge-soft-info'
									onClick={() => showHideModal('edit_phone')}
									data-toggle='tooltip'
									title={genPageData['GENEDT'] ? genPageData['GENEDT'] : ''}
								>
									<i className='far fa-edit profileEditContent'></i>
								</Badge>
							</Col>
						</>
					) : (
						<Col lg={12} md='6' sm='12' className='mb-1'>
							<p style={{ textAlign: 'center' }}>
								{pageLanguageContent['PRL086'] ? pageLanguageContent['PRL086'] : ''}.
							</p>
						</Col>
					)}
				</Row>
			</fieldset>

			<EditProfileNameModal
				showHide={showHideEditProfileNameModal}
				onClick={closeAllModals}
				data={data}
				pageLanguageContent={pageLanguageContent}
				setInputField={setInputField}
				inputField={inputField}
				type={type}
				updateModal={updateModal}
				copiriGenderList={copiriGenderList}
			/>
			<AddEditProfileAddressModal
				showHide={showHideAddEditAddressModal}
				onClick={closeAllModals}
				data={data}
				pageLanguageContent={pageLanguageContent}
				countriesData={countriesData}
				setInputField={setInputField}
				inputField={inputField}
				type={type}
				updateModal={updateModal}
				itemData={itemData}
			/>

			<AddEditProfileEmailModal
				showHide={showHideAddEditEmailModal}
				onClick={closeAllModals}
				data={data}
				pageLanguageContent={pageLanguageContent}
				countriesData={countriesData}
				type={type}
				setInputField={setInputField}
				inputField={inputField}
				updateModal={updateModal}
			/>

			<AddEditProfilePhoneModal
				showHide={showHideAddEditPhoneModal}
				onClick={closeAllModals}
				data={data}
				pageLanguageContent={pageLanguageContent}
				countriesData={countriesData}
				type={type}
				setInputField={setInputField}
				inputField={inputField}
				updateModal={updateModal}
				dailCodes={dailCodes}
			/>
			<EditProfileDateModal
				showHide={showHideEditProfileDateModal}
				onClick={closeAllModals}
				data={data}
				pageLanguageContent={pageLanguageContent}
				setInputField={setInputField}
				inputField={inputField}
				type={type}
				updateModal={updateModal}
				copiriGenderList={copiriGenderList}
				dateGenderType={dateGenderType}
				dob={date}
			/>
		</>
	);
};
export default UserProfilePersonalInforamtion;
